// Wave AW.3-React (2026-05-16) — 외부 바이어 대시보드 (메인 placeholder).
// 공통 layout (AuctionBuyerLayout) 으로 네비 바 공유.

import React from 'react';
import AuctionBuyerLayout from './AuctionBuyerLayout';

function AuctionBuyerDashboard() {
  var buyer = (function(){ try { return JSON.parse(sessionStorage.getItem('autodex_buyer')||'null'); } catch(e) { return null; } })();

  return (
    <AuctionBuyerLayout activeKey={null}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '60px 32px', textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16, opacity: 0.4 }}>🚧</div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#475569', marginBottom: 8 }}>
          환영합니다, {buyer && buyer.name ? buyer.name : '바이어'}님
        </h2>
        <p style={{ fontSize: 15, color: '#94a3b8' }}>
          상단 메뉴에서 진행중 경매를 둘러보세요
        </p>
      </div>
    </AuctionBuyerLayout>
  );
}

export default AuctionBuyerDashboard;
